
import { BlogPost } from '../types';

// Blog post: "Tritonussubstitutioner i jazz – en vej til spænding og farve"
export const tritonusPost: BlogPost = {
  id: 9,
  title: "Tritonussubstitutioner i jazz – en vej til spænding og farve",
  slug: "tritonussubstitutioner-i-jazz",
  excerpt: "Lær hvordan tritonussubstitutioner kan tilføje nye farver og spænding til dit jazzklaver og improvisation.",
  content: `
      <h2>Hvad er en tritonus?</h2>
      <p>En tritonus er et interval på tre hele toner – fx fra C til F#. Det lyder dissonant, ustabilt og kræver ofte en opløsning. Og det er netop den egenskab, vi kan udnytte i substitutioner.</p>
      
      <h2>Hvad er en tritonussubstitution?</h2>
      <p>Kort sagt: Når du erstatter en dominantakkord med en anden dominantakkord, som ligger en tritonus væk. Det klassiske eksempel:</p>
      <p>I stedet for G7 (dominant i C-dur), spiller du Db7.</p>
      
      <h2>Hvorfor virker det?</h2>
      <ul>
        <li>G7 og Db7 deler de samme ledetoner: B og F i G7 og F og Cb (enharmonisk med B) i Db7 skaber samme spænding mod tonika (C).</li>
        <li>De fører begge mod C, men med forskellig klangfarve.</li>
      </ul>
      
      <h2>Hvordan bruger man tritonussubstitution?</h2>
      <p>Den mest almindelige brug er i II–V–I-kadencer, fx i C-dur:</p>
      <p>Dm7 – G7 – Cmaj7 bliver til:<br>
      Dm7 – Db7 – Cmaj7</p>
      <p>Her skaber Db7 en overraskende men tilfredsstillende vej til Cmaj7. Lyt gerne til jazzstandarder som All the Things You Are eller Have You Met Miss Jones? – her dukker tritonussubstitutioner ofte op.</p>
      
      <h2>Eksempler i praksis</h2>
      <ol>
        <li>
          <strong>Komp med substitutionsdominant</strong>
          <p>I stedet for en klassisk V7, prøv en tritonusvariant for at skabe mere farve.<br>
          Fx i "Autumn Leaves" kan du spille:<br>
          | Am7 | D7 | Gmaj7 |<br>
          …og i stedet for D7 spille Ab7 – det giver en anderledes lyd, men virker stadig!</p>
        </li>
        <li>
          <strong>Improvisation</strong>
          <p>Når du improviserer over en V7, kan du "tænke" den tritonale substitution og bruge tonearter og licks fra fx Db7 i stedet for G7 – det åbner for nye farver og muligheder.</p>
        </li>
      </ol>
      
      <h2>Tips til at komme i gang</h2>
      <ul>
        <li>Find en håndfuld II–V–I-kadencer, og prøv at udskifte V7 med tritonus-sub'en.</li>
        <li>Øv dig i at høre forskellen – lyt til optagelser og spil selv.</li>
        <li>Leg med substitutionsdominanter i dine egne arrangementer – især i outroer og vamps.</li>
      </ul>
      
      <h2>Konklusion</h2>
      <p>Tritonussubstitutioner giver dig mulighed for at skabe spænding, variation og farve i dit spil – uden at du nødvendigvis bevæger dig langt væk fra det harmoniske grundlag. Når først dine ører og hænder har vænnet sig til det, vil du opdage, hvor mange steder det kan bruges.</p>
      <p>Har du lyst til at arbejde med tritonussubstitutioner og jazzharmonik i din undervisning? Så skriv til mig – det er noget af det mest inspirerende at udforske sammen ved klaveret.</p>
    `,
  date: "05.04.2025",
  author: "Oscar Gilbert",
  category: "Avancerede emner",
  image: "/lovable-uploads/7c28979b-41c9-4b80-be30-e7c99ca8665c.png",
  tags: ["jazz", "harmonik", "improvisation", "akkorder"],
  readTime: "6 min"
};
